__turbopack_context__.v({
  "blok-big-title": "Counter-module__sc7Axq__blok-big-title",
  "blok-subtitle": "Counter-module__sc7Axq__blok-subtitle",
  "blok-title": "Counter-module__sc7Axq__blok-title",
  "quantity-button": "Counter-module__sc7Axq__quantity-button",
  "quantity-input": "Counter-module__sc7Axq__quantity-input",
  "yarn-quantity-disabled": "Counter-module__sc7Axq__yarn-quantity-disabled",
  "yarn-quantity-large": "Counter-module__sc7Axq__yarn-quantity-large",
});
